// extracted by mini-css-extract-plugin
export default {"username":"MainHeader_username__XDmeG"};